export const FIELD_STAFF_ROLE_ID = 'ec32aba0-0b8e-11ef-a972-b57fdf832e73';
